// import { tariffFields } from '../../utils/api';
import { additionCodedata, genAdditionalInput } from '../../utils/euro';
import { genCurrencySelect, genSelect, genUnit, getOption } from '../../utils/select';
import { ELEMENT_TYPE, getPrice, nFormatter, Track } from '../../utils/utils';
import { checkSearchForm } from '../../utils/validate';

const $ = window.jQuery;
const edit = require('../../assets/images/edit.svg');

export const genOrderInfoForm = (data = []) => {
  const parent = $('#order-info .input-list');
  parent.html('');
  if (Array.isArray(data) && data.length && (data[0].name || data[0].value)) {
    data.forEach(item => {
      genOrderInfoItem(parent, item);
    });
    $('#order-info .box.order-info').removeClass('report-done').removeClass('not-found');
    $('#order-info .box.order-info .message').text("");
  } else {
    $('#order-info .box.order-info').removeClass('report-done');
    $('#order-info .box.order-info .message').text("No input required to retrieve the tariff");
  }

  // else {
  //   tariffFields({
  //     destination: window.searchData.destination,
  //     product: window.searchData.hs,
  //     origin: window.searchData.export,
  //     not_found: true
  //   }, function (data) { }, function (error) {
  //     console.error(error)
  //   })
  //   $('#order-info .box.order-info').removeClass('report-done').addClass('not-found');
  // }
}

export const genOrderInfoItem = (selecter, item) => {
  if (!item.name && !item.value) {
    return;
  }
  let hint = '';
  if (item.hint && item.hint !== item.label) {
    hint = `<div class="instruction">
          <div class="dropdown">
            <div class="content">
              ${item.hint}
            </div>
          </div>
        </div>`;
  }
  let value = window.searchData[item.name] || item.default_value || '';
  let unit = item.type === "currency" ? window.searchData.currency || 'USD' : item.unit === 'uom' ? window.searchData.uom : item.unit;
  let element = $(`
    <div class="multi-form-group ${item.type} ${item.name}">
      <div class="form-group ${item.name}${unit ? '' : ' no-unit'}">
        ${!item.label ? "" : '<label class="' + (window.searchData.destination === "NO" ? "translate " : "") + 'label">' + item.label + hint + '</label>'}
        <div class='input-box ${item.type}'>
          <div class="${window.searchData.destination === "NO" ? "translate " : ""}input"></div>
          <div class='border'></div>
          <div class="unit ${unit} hidden"></div>
        </div>
        <div class="invalid-feedback">
          Please enter a valid ${item.name}.
        </div>
      </div>
      <div class='sub-input-box'>
      </div>
    <div>
  `);
  element.appendTo(selecter);
  switch (item.type) {
    case 'currency':
      element.find('.input').html(`<input class="form-control input-field ${item.name}" value='${value}' name="${item.name}" />`);
      element.find('.input input').maskMoney({
        precision: 0
      });
      genCurrencySelect(element.find('.unit'), window.searchData.currency);
      window.searchData[item.name] = getPrice(value);
      window.searchData.currency = element.find('.unit select').val();
      element.find('.input input').on('keyup', function (e) {
        window.searchData[item.name] = getPrice($(this).val());
        setOrderInfoLabel();
      });
      element.find('.input input').on('blur', function (e) {
        window.searchData[item.name] = getPrice($(this).val());
        setOrderInfoLabel();
      });
      element.find('.unit select').on('change', function (e) {
        window.searchData.currency = $(this).val();
        setOrderInfoLabel();
      });
      element.find('.input input').attr("tfc", Track.genNormalTrack("", "order-info-popup", item.name, ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
      element.find('.input input').attr("tfh", Track.genNormalTrack("", "order-info-popup", item.name, ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
      element.find('.unit .selectize-control').attr("tfc", Track.genNormalTrack("", "order-info-popup", item.name + '_unit', ELEMENT_TYPE.SELECT, "", 3000, 0, 1));
      element.find('.unit .selectize-control').attr("tfh", Track.genNormalTrack("", "order-info-popup", item.name + '_unit', ELEMENT_TYPE.SELECT, "", 3000, 0, 1));
      setOrderInfoLabel();
      break;
    case 'europaAdditionalAgricultural':
      element.find('.input').html(`<input type="hidden" class="input-field ${item.name}" value='${value}' name="${item.name}" />`);
      window.searchData[item.name] = element.find(`input[name=${item.name}]`).val();
      element.find(`input[name=${item.name}]`).on('change', function (e) {
        window.searchData[item.name] = $(this).val();
        setOrderInfoLabel();
      });
      genAdditionalInput(item, element, 0);
      setOrderInfoLabel();
      break;
    case 'select':
      genSelect(element.find(`> .form-group.${item.name} > .input-box > .input`), item.options, value, item.name, `input-field ${item.name}`, function (value) {
        window.searchData[item.name] = value;
        let option = getOption(item.options, value);
        if (option && Array.isArray(option.fields)) {
          option.fields.forEach(sub => {
            const subParent = element.find('> .sub-input-box');
            subParent.html('');
            genOrderInfoItem(subParent, sub);
          })
        } else {
          element.find('> .sub-input-box').html('');
        }
        setOrderInfoLabel();
      }, function (value) {
        window.searchData[item.name] = value;
        let option = getOption(item.options, value);
        if (option && Array.isArray(option.fields)) {
          option.fields.forEach(sub => {
            const subParent = element.find('> .sub-input-box');
            subParent.html('');
            genOrderInfoItem(subParent, sub);
          })
        } else {
          element.find('> .sub-input-box').html('');
        }
        setOrderInfoLabel();
      })
      element.find(`.form-group.${item.name} .input-box .input > .selectize-control`).attr("tfc", Track.genNormalTrack("", "order-info-popup", item.name, ELEMENT_TYPE.SELECT, "", 3000, 0, 1));
      element.find(`.form-group.${item.name} .input-box .input > .selectize-control`).attr("tfh", Track.genNormalTrack("", "order-info-popup", item.name, ELEMENT_TYPE.SELECT, "", 3000, 0, 1));
      break;
    case 'mselect':
      genSelect(element.find(`> .form-group.${item.name} > .input-box > .input`), item.options, value, item.name, `input-field ${item.name}`, function (value) {
        window.searchData[item.name] = value;
        // let option = getOption(item.options, value);
        // if (option && Array.isArray(option.fields)) {
        //   option.fields.forEach(sub => {
        //     const subParent = element.find('> .sub-input-box');
        //     subParent.html('');
        //     genOrderInfoItem(subParent, sub);
        //   })
        // } else {
        //   element.find('> .sub-input-box').html('');
        // }
        setOrderInfoLabel();
      }, function (value) {
        window.searchData[item.name] = value;
        // let option = getOption(item.options, value);
        // if (option && Array.isArray(option.fields)) {
        //   option.fields.forEach(sub => {
        //     const subParent = element.find('> .sub-input-box');
        //     subParent.html('');
        //     genOrderInfoItem(subParent, sub);
        //   })
        // } else {
        //   element.find('> .sub-input-box').html('');
        // }
        setOrderInfoLabel();
      }, true)
      element.find(`.form-group.${item.name} .input-box .input > .selectize-control`).attr("tfc", Track.genNormalTrack("", "order-info-popup", item.name, ELEMENT_TYPE.SELECT, "", 3000, 0, 1));
      element.find(`.form-group.${item.name} .input-box .input > .selectize-control`).attr("tfh", Track.genNormalTrack("", "order-info-popup", item.name, ELEMENT_TYPE.SELECT, "", 3000, 0, 1));
      break;
    case 'checkbox':
      if (Array.isArray(item.options)) {
        item.options.forEach(option => {
          if (!Array.isArray(window.searchData[item.name]) && window.searchData[item.name]) {
            window.searchData[item.name] = [window.searchData[item.name]];
          }
          let checked = Array.isArray(window.searchData[item.name]) && window.searchData[item.name].includes(option.value);
          element.find('> .form-group > .input-box > .input').append($(`<label class="form-check-label"><input type="checkbox" value='${option.value}' name="${item.name}" />${option.label || option.name}</label>`));
          element.find(`.input input[name=${item.name}][value="${option.value}"]`).on('change', function () {
            window.searchData[item.name] = [];
            element.find(`.input input[name=${item.name}]:checked`).each((i, e) => {
              window.searchData[item.name].push($(e).val());
            })
            let thisValue = $(this).val();
            let option = getOption(item.options, thisValue);
            if (option && Array.isArray(option.fields)) {
              option.fields.forEach(sub => {
                const subParent = element.find('> .sub-input-box');
                subParent.html('');
                genOrderInfoItem(subParent, sub);
              })
            } else {
              element.find('> .sub-input-box').html('');
            }
            setOrderInfoLabel();
          });
          element.find(`.input input[name=${item.name}][value=${option.value}]`).prop('checked', checked).trigger('change');
          element.find(`.input input[name=${item.name}][value=${option.value}]`).attr("tfc", Track.genNormalTrack("", "order-info-popup", `${item.name}_${option.value}`, ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
          element.find(`.input input[name=${item.name}][value=${option.value}]`).attr("tfh", Track.genNormalTrack("", "order-info-popup", `${item.name}_${option.value}`, ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
        });
      }
      setOrderInfoLabel();
      break;
    case 'radio':
      if (Array.isArray(item.options)) {
        item.options.forEach(option => {
          let checked = value === option.value;
          element.find('> .form-group > .input-box > .input').append($(`<label class="form-check-label"><input type="radio" value='${option.value}' name="${item.name}" />${option.label || option.name}</label>`));
          element.find(`.input input[name=${item.name}][value="${option.value}"]`).on('change', function () {
            if (this.checked) {
              let thisValue = $(this).val();
              window.searchData[item.name] = $(this).val();
              let option = getOption(item.options, thisValue);
              if (option && Array.isArray(option.fields)) {
                option.fields.forEach(sub => {
                  const subParent = element.find('> .sub-input-box');
                  subParent.html('');
                  genOrderInfoItem(subParent, sub);
                })
              } else {
                element.find('> .sub-input-box').html('');
              }
            }
            setOrderInfoLabel();
          });
          if (checked) {
            element.find(`.input input[name=${item.name}][value="${option.value}"]`).prop('checked', checked).trigger('change');
          }
          element.find(`.input input[name=${item.name}][value="${option.value}"]`).attr("tfc", Track.genNormalTrack("", "order-info-popup", `${item.name}_${option.value}`, ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
          element.find(`.input input[name=${item.name}][value="${option.value}"]`).attr("tfh", Track.genNormalTrack("", "order-info-popup", `${item.name}_${option.value}`, ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
        });
      }
      setOrderInfoLabel();
      break;
    case 'integer':
      element.find('.input').html(`<input class="form-control" value='${value}' name="${item.name}" />`);
      element.find('.input input').inputFilter(function (value) {
        return /^-?\d*$/.test(value);
      });
      genUnit(element.find('.unit'), unit);
      window.searchData[item.name] = getPrice(value);
      element.find('.input input').on('keyup', function (e) {
        window.searchData[item.name] = getPrice($(this).val());
        setOrderInfoLabel();
      });
      element.find('.input input').on('blur', function (e) {
        window.searchData[item.name] = getPrice($(this).val());
        setOrderInfoLabel();
      });
      setOrderInfoLabel();
      element.find('.input input').attr("tfc", Track.genNormalTrack("", "order-info-popup", item.name, ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
      element.find('.input input').attr("tfh", Track.genNormalTrack("", "order-info-popup", item.name, ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
      element.find('.unit input').attr("tfc", Track.genNormalTrack("", "order-info-popup", item.name + '_unit', ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
      element.find('.unit input').attr("tfh", Track.genNormalTrack("", "order-info-popup", item.name + '_unit', ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
      element.find('.unit .selectize-control').attr("tfc", Track.genNormalTrack("", "order-info-popup", item.name + '_unit', ELEMENT_TYPE.SELECT, "", 3000, 0, 1));
      element.find('.unit .selectize-control').attr("tfh", Track.genNormalTrack("", "order-info-popup", item.name + '_unit', ELEMENT_TYPE.SELECT, "", 3000, 0, 1));
      break;
    default:
      element.find('.input').html(`<input class="form-control" value='${value}' name="${item.name}" />`);
      element.find('.input input').inputFilter(function (value) {
        return /^-?\d*[.]?\d*$/.test(value);
      });
      genUnit(element.find('.unit'), unit);
      window.searchData[item.name] = getPrice(value);
      element.find('.input input').on('keyup', function (e) {
        window.searchData[item.name] = getPrice($(this).val());
        setOrderInfoLabel();
      });
      element.find('.input input').on('blur', function (e) {
        window.searchData[item.name] = getPrice($(this).val());
        setOrderInfoLabel();
      });
      setOrderInfoLabel();
      element.find('.input input').attr("tfc", Track.genNormalTrack("", "order-info-popup", item.name, ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
      element.find('.input input').attr("tfh", Track.genNormalTrack("", "order-info-popup", item.name, ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
      element.find('.unit input').attr("tfc", Track.genNormalTrack("", "order-info-popup", item.name + '_unit', ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
      element.find('.unit input').attr("tfh", Track.genNormalTrack("", "order-info-popup", item.name + '_unit', ELEMENT_TYPE.INPUT, "", 3000, 0, 1));
      element.find('.unit .selectize-control').attr("tfc", Track.genNormalTrack("", "order-info-popup", item.name + '_unit', ELEMENT_TYPE.SELECT, "", 3000, 0, 1));
      element.find('.unit .selectize-control').attr("tfh", Track.genNormalTrack("", "order-info-popup", item.name + '_unit', ELEMENT_TYPE.SELECT, "", 3000, 0, 1));
      break;
  }
  if (Array.isArray(item.fields)) {
    item.fields.forEach(sub => {
      const subParent = element.find('.sub-input-box');
      subParent.html('');
      genOrderInfoItem(subParent, sub);
    })
  }
}

export const setOrderInfoDetail = () => {
  let html = '';
  window.orderInfo.forEach(element => {
    html += genOrderInfoDetailItem(element);
  });
  $(".section-overview .country .custom-fields").html(html);

  $('.section-overview .custom-fields .edit').each(function (i, obj) {
    $(obj).attr("tfc", Track.genNormalTrack("", "overview-custom-fields", 'edit_' + $(obj).parent().parent().attr('class').replace('field ', ''), ELEMENT_TYPE.BUTTON, "", 3000, 0, 1));
    $(obj).attr("tfh", Track.genNormalTrack("", "overview-custom-fields", 'edit_' + $(obj).parent().parent().attr('class').replace('field ', ''), ELEMENT_TYPE.BUTTON, "", 3000, 0, 1));
  });
}

export const genOrderInfoDetailItem = (element) => {
  if (!element.name && !element.value) {
    return '';
  }
  let html = '';
  let hint = '';
  let unit = element.type === "currency" ? window.searchData.currency : element.unit === 'uom' ? window.searchData.uom : element.unit;
  let valueFull = getPrice(window.searchData[element.name]);
  let value = nFormatter(valueFull, 1);
  if (element.type === 'select') {
    value = window.searchData[element.name];
  }
  switch (element.type) {
    case 'europaAdditionalAgricultural':
      html += `
        <div class='field no-border ${element.name}'>
          <div class='title'>
            ${element.label}
          </div>
        </div>
      `;
      additionCodedata.fields.forEach(item => {
        let subHint = '';
        if (item.hint && item.hint !== item.label) {
          subHint = `<div class="instruction">
                <div class="dropdown">
                  <div class="content">
                    ${item.hint}
                  </div>
                </div>
              </div>`;
        }
        html += `
          <div class='sub-field field ${item.name}'>
            <div class='title'>
              ${item.label}
              ${subHint}
            </div>
            <div class='value-box'>
              <span class="value">${item.value[window.searchData[item.name]]} ${unit}</span>
              <img data-target="#order-info .input-list .${item.name} .input-box .input select" alt="edit"
                src="${edit}" class="edit" />
            </div>
          </div>
        `;
      })
      break;
    case 'checkbox':
      if (element.hint && element.hint !== element.label) {
        hint = `<div class="instruction">
                <div class="dropdown">
                  <div class="content">
                    ${element.hint}
                  </div>
                </div>
              </div>`;
      }
      value = '';
      if (Array.isArray(window.searchData[element.name])) {
        window.searchData[element.name].forEach((e, i) => {
          value += `${e}${i < window.searchData[element.name].length - 1 ? ', ' : ''}`
        })
      }
      html += `
          <div class='field ${element.name}'>
            <div class='title'>
              ${element.label}
              ${hint}
            </div>
            <div class='value-box'>
              <span class="value">${value} ${unit}</span>
              <img data-target="#order-info .input-list .${element.name} .input-box .input" alt="edit"
                src="${edit}" class="edit" />
            </div>
          </div>
        `;
      let option = getOption(element.options, window.searchData[element.name]);
      if (option && Array.isArray(option.fields)) {
        option.fields.forEach(sub => {
          html += genOrderInfoDetailItem(sub);
        })
      }
      break;
    case 'radio':
      if (element.hint && element.hint !== element.label) {
        hint = `<div class="instruction">
                  <div class="dropdown">
                    <div class="content">
                      ${element.hint}
                    </div>
                  </div>
                </div>`;
      }
      value = window.searchData[element.name];
      html += `
            <div class='field ${element.name}'>
              <div class='title'>
                ${element.label}
                ${hint}
              </div>
              <div class='value-box'>
                <span class="value">${value} ${unit}</span>
                <img data-target="#order-info .input-list .${element.name} .input-box .input" alt="edit"
                  src="${edit}" class="edit" />
              </div>
            </div>
          `;
      const sub = getOption(element.options, window.searchData[element.name]);
      if (sub && Array.isArray(sub.fields)) {
        sub.fields.forEach(sub => {
          html += genOrderInfoDetailItem(sub);
        })
      }
      break;
    case 'select': case 'mselect':
      if (element.hint && element.hint !== element.label) {
        hint = `<div class="instruction">
                  <div class="dropdown">
                    <div class="content">
                      ${element.hint}
                    </div>
                  </div>
                </div>`;
      }
      if (Array.isArray(window.searchData[element.name])) {
        value = '';
        window.searchData[element.name].forEach((e, i) => {
          let option = getOption(element.options, e);
          if (option.value) {
            value += `${option.label || option.value}${i < window.searchData[element.name].length - 1 ? ', ' : ''}`
          }
        })
      } else {
        let option = getOption(element.options, value);
        if (option.value) {
          value = option.label || option.value
        }
      }
      html += `
            <div class='field ${element.name}'>
              <div class='title'>
                ${element.label}
                ${hint}
              </div>
              <div class='value-box'>
                <span class="value">${value} ${unit}</span>
                <img data-target="#order-info .input-list .${element.name} .input-box .input select" alt="edit"
                  src="${edit}" class="edit" />
              </div>
            </div>
          `;
      let ioption = getOption(element.options, window.searchData[element.name]);
      if (ioption && Array.isArray(ioption.fields)) {
        ioption.fields.forEach(sub => {
          html += genOrderInfoDetailItem(sub);
        })
      }
      break;
    default:
      if (element.hint && element.hint !== element.label) {
        hint = `<div class="instruction">
                <div class="dropdown">
                  <div class="content">
                    ${element.hint}
                  </div>
                </div>
              </div>`;
      }
      html += `
          <div class='field ${element.name}'>
            <div class='title'>
              ${element.label}
              ${hint}
            </div>
            <div class='value-box'>
              <span title="${valueFull} ${unit}" class="value">${value} ${unit}</span>
              <img data-target="#order-info .input-list .${element.name} .input-box .input ${element.type !== 'select' ? 'input' : 'select'}" alt="edit"
                src="${edit}" class="edit" />
            </div>
          </div>
        `;
      break;
  }
  if (Array.isArray(element.fields)) {
    element.fields.forEach(sub => {
      html += genOrderInfoDetailItem(sub);
    })
  }
  return html;
}

export function setOrderInfoLabel() {
  let text = '';
  let done = true;
  let full = '';
  if (window.orderInfo) {
    for (let i = 0; i < window.orderInfo.length; i++) {
      const element = window.orderInfo[i];
      [text, done, full] = setOrderInfoLabelItem(element, text, done, full);
      if (!done) {
        break;
      }
    }
  }
  $(".order-info .order-info-label").html(`
    <span title="${done ? full : ''}">${done ? text : ''}</span>
  `);
  checkSearchForm();
}

export const setOrderInfoLabelItem = (element, text, done, full) => {
  if (!element.name && !element.value) {
    return [text, done, full];
  }
  let value = window.searchData[element.name];
  let unit = element.type === "currency" ? window.searchData.currency : element.unit === 'uom' ? window.searchData.uom : element.unit;
  unit = unit ? ' ' + unit : '';
  if ((value || element.type === 'checkbox') && !(element.type === 'mselect' && Array.isArray(value) && !value.length)) {
    switch (element.type) {
      case 'europaAdditionalAgricultural':
        break;
      case 'select': case 'mselect':
        if (Array.isArray(window.searchData[element.name])) {
          value = '';
          window.searchData[element.name].forEach((e, i) => {
            let option = getOption(element.options, e);
            if (option.value) {
              value += `${option.label || option.value}${i < window.searchData[element.name].length - 1 ? ', ' : ''}`
            }
          })
        } else {
          let option = getOption(element.options, value);
          if (option.value) {
            value = option.label || option.value
          }
        }
        text += `${value}${unit}; `;
        full += `${value}${unit}; `;
        let option = getOption(element.options, window.searchData[element.name]);
        if (option && Array.isArray(option.fields)) {
          option.fields.forEach(sub => {
            [text, done, full] = setOrderInfoLabelItem(sub, text, done, full);
          })
        }
        break;
      case 'checkbox':
        if (Array.isArray(value)) {
          for (let j = 0; j < value.length; j++) {
            const item = value[j];
            text += `${item}; `;
            full += `${item}; `;
            let optioni = getOption(element.options, item);
            if (optioni && Array.isArray(optioni.fields)) {
              for (let i = 0; i < optioni.fields.length; i++) {
                const sub = optioni.fields[i];
                [text, done, full] = setOrderInfoLabelItem(sub, text, done, full);
              }
            }
          }
        }
        break;
      case 'radio':
        text += `${value}; `;
        full += `${value}; `;
        let optioni = getOption(element.options, value);
        if (optioni && Array.isArray(optioni.fields)) {
          for (let i = 0; i < optioni.fields.length; i++) {
            const sub = optioni.fields[i];
            [text, done, full] = setOrderInfoLabelItem(sub, text, done, full);
          }
        }
        break;
      default:
        text += `${nFormatter(getPrice(window.searchData[element.name]), 1)}${unit}; `;
        full += `${getPrice(window.searchData[element.name])}${unit}; `;
        break;
    }
  } else {
    done = false;
  }
  return [text, done, full];
}

export const resetOrderInfo = () => {
  window.searchData = {
    destination: window.searchData.destination,
    export: window.searchData.export,
    hs: window.searchData.hs,
    uom: window.searchData.uom
  }
}

export const genOrderInfoQuery = (query) => {
  if (window.orderInfo) {
    window.orderInfo.forEach(element => {
      genOrderInfoQueryItem(query, element);
    });
  }
  return query;
}

export const genOrderInfoQueryItem = (query, element) => {
  switch (element.type) {
    case 'europaAdditionalAgricultural':
      additionCodedata.fields.forEach(item => {
        query[item.name] = encodeURIComponent(window.searchData[item.name]);
      })
      break;
    case 'select': case 'mselect':
      query[element.name] = encodeURIComponent(window.searchData[element.name]);
      let option = getOption(element.options, window.searchData[element.name]);
      if (option && Array.isArray(option.fields)) {
        option.fields.forEach(sub => {
          query = genOrderInfoQueryItem(query, sub);
        })
      }
      break;
    case 'checkbox':
      query[element.name] = encodeURIComponent(window.searchData[element.name]);
      if (Array.isArray(window.searchData[element.name])) {
        window.searchData[element.name].forEach(e => {
          let optionc = getOption(element.options, e);
          if (optionc && Array.isArray(optionc.fields)) {
            optionc.fields.forEach(sub => {
              query = genOrderInfoQueryItem(query, sub);
            })
          }
        })
      }
      break;
    case 'radio':
      query[element.name] = encodeURIComponent(window.searchData[element.name]);
      let optionc = getOption(element.options, window.searchData[element.name]);
      if (optionc && Array.isArray(optionc.fields)) {
        optionc.fields.forEach(sub => {
          query = genOrderInfoQueryItem(query, sub);
        })
      }
      break;
    default:
      query[element.name] = encodeURIComponent(window.searchData[element.name]);
      break;
  }
  return query;
}

export const genOrderInfoApiParam = (query, element, params) => {
  switch (element.type) {
    case 'europaAdditionalAgricultural':
      query.custom_param[element.name] = params[element.name];
      break;
    case 'select': case 'mselect':
      query.custom_param[element.name] = params[element.name];
      let option = getOption(element.options, window.searchData[element.name]);
      if (option && Array.isArray(option.fields)) {
        option.fields.forEach(sub => {
          query = genOrderInfoApiParam(query, sub, params);
        })
      }
      break;
    case 'checkbox':
      query.custom_param[element.name] = params[element.name];
      if (Array.isArray(window.searchData[element.name])) {
        window.searchData[element.name].forEach(e => {
          let optioni = getOption(element.options, e);
          if (optioni && Array.isArray(optioni.fields)) {
            optioni.fields.forEach(sub => {
              query = genOrderInfoApiParam(query, sub, params);
            })
          }
        });
      }
      break;
    case 'radio':
      query.custom_param[element.name] = params[element.name];
      let optioni = getOption(element.options, window.searchData[element.name]);
      if (optioni && Array.isArray(optioni.fields)) {
        optioni.fields.forEach(sub => {
          query = genOrderInfoApiParam(query, sub, params);
        })
      }
      break;
    default:
      query.custom_param[element.name] = params[element.name] * 1
      break;
  }
  return query;
}